function initLightbox() {
  if (!window.matchMedia('(min-width: 1024px)').matches) return;
  if (typeof GLightbox === 'undefined') return;

  const gallery = document.querySelector('[data-js-product-gallery]');
  if (!gallery) return;

  const elements = Array.from(gallery.querySelectorAll('[data-lightbox]'))
    .sort((a, b) => parseInt(a.dataset.lightboxIndex) - parseInt(b.dataset.lightboxIndex))
    .map(el => ({
      href: el.dataset.lightbox,
      type: el.dataset.lightboxType
    }));

  if (!elements.length) return;

  window.lightbox = GLightbox({
    elements: elements,
    touchNavigation: true,
    keyboardNavigation: true,
    closeOnOutsideClick: true,
    autoplayVideos: true,
    openEffect: 'none',
    closeEffect: 'none',
    plyr: {
      config: {
        keyboard: { focused: false, global: false }
      }
    },
    onOpen: () => {
      document.querySelectorAll('.product-gallery video').forEach(v => v.pause());
      const stickyBlock = document.querySelector('.product-text.product-text-gallery');
      if (stickyBlock) stickyBlock.style.visibility = 'hidden';

      const lightboxEl = document.querySelector('.glightbox-container');
      if (lightboxEl && !lightboxEl.dataset.wheelBound) {
        lightboxEl.dataset.wheelBound = '1';
        lightboxEl.addEventListener('wheel', (e) => {
          const slide = lightboxEl.querySelector('.gslide.current.zoomed');
          if (!slide) return;
          const img = slide.querySelector('.gslide-image img');
          if (!img) return;
          const mover = img.parentNode;
          e.preventDefault();

          const m = new DOMMatrixReadOnly(window.getComputedStyle(mover).transform);
          let x = m.m41 - e.deltaX;
          let y = m.m42 - e.deltaY;

          const rect = img.getBoundingClientRect();
          const maxX = Math.max(0, (rect.width - window.innerWidth) / 2);
          const maxY = Math.max(0, (rect.height - window.innerHeight) / 2);

          x = Math.max(-maxX, Math.min(maxX, x));
          y = Math.max(-maxY, Math.min(maxY, y));

          mover.style.transform = `translate3d(${x}px, ${y}px, 0)`;
        }, { passive: false });
      }
    },
    onClose: () => {
      const stickyBlock = document.querySelector('.product-text.product-text-gallery');
      if (stickyBlock) stickyBlock.style.visibility = 'visible';
      document.querySelectorAll('.product-gallery video').forEach(v => {
        if (v.closest('.product-gallery-item').classList.contains('css-slide-active')) {
          v.play().catch(() => {});
        }
      });
    }
  });

  gallery.querySelectorAll('[data-lightbox]').forEach(el => {
    el.style.cursor = el.dataset.lightboxType === 'video' ? 'pointer' : 'zoom-in';
  });

  gallery.addEventListener('click', (e) => {
    const el = e.target.closest('[data-lightbox]');
    if (!el) return;
    if (e.target.closest('.btn_theed')) return;

    const video = el.querySelector('video');
    if (video) {
      e.preventDefault();
      e.stopPropagation();
      if (video.paused) video.play().catch(() => {});
      else video.pause();
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    const index = parseInt(el.dataset.lightboxIndex);
    window.lightbox.openAt(index);
  }, true);
}

const observer = new MutationObserver(() => {
  if (document.querySelector('[data-js-product-gallery] [data-lightbox]')) {
    observer.disconnect();
    initLightbox();
  }
});

observer.observe(document.body, { childList: true, subtree: true });
